import TopicPageTemplate from '@templates/topic-page/detail';

// ---------------------------------------------------------

import { getTopicLandingProps } from '@lib/topic-landing-props';

// ---------------------------------------------------------

export async function getStaticProps(context) {
  return getTopicLandingProps('Mortgage', context);
}

// ---------------------------------------------------------

const Home = ({ pageData, preview }) => {
  return (
    <TopicPageTemplate
      collection="Mortgage"
      coreService
      pageData={pageData}
      preview={preview}
    ></TopicPageTemplate>
  );
};

export default Home;
